import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
`;

export const Wrapper = styled.div` 
    width: 100%;
    height: 100vh;

    display: flex;

    background-color: #FFFF;

    @media (max-width: 767px) {
        overflow: auto;
        
        padding: 0 1.5rem 5rem;

        gap: 3rem;
        align-items: center;
        flex-direction: column;

        background-color: ${theme.colors.gray.Cinza_1};
    }
`;

export const ContainerDescription = styled.div` 
    width: 50%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: #292E38;

    @media (max-width: 767px) {
        width: 100%;
        height: auto;

        align-items: flex-start;

        background-color: transparent;
    }
`;

export const Description = styled.div` 
    width: auto;
    height: auto;

    gap: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    >img{
        width: auto;
        height: 2rem;

        margin-bottom: 0.875rem;
    }

    @media (max-width: 767px) {
        max-width: 20.4375rem;

        gap: 0.75rem;
        align-items: center;

        >img{
            height: 1.5rem;

            margin-top: 5rem;
            margin-bottom: 3rem;
        }

        >h3{
            text-align: center;

            font-size: 1.75rem;
            line-height: 2.275rem;
        }

        >p{
            text-align: center;

            font-size: 1rem;
            line-height: 1.6rem;
        }
    }
`;

export const NoCreditCard = styled.div` 
    width: auto;
    height: auto;
    padding: 0.3125rem 0.3125rem 0.3125rem 0.5rem;

    gap: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 10rem;
    background-color: #E9ECF0;

    @media (max-width: 767px) {
        background-color: #292E38;

        >span{
            color: #FFFFFF;
            font-size: 0.5625rem;
            line-height: 0.84375rem;
        }
    }
`;

export const ContainerForm = styled.div` 
    width: 50%;
    height: auto;
 
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    background-color: #FFFFFF;

    @media (max-width: 767px) {
        width: 100%;

        background-color: transparent;
    }
`;

export const Form = styled.div` 
    width: 100%;
    height: auto;
    max-width: 26.25rem;
 
    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 767px) {  
        padding: 2rem 1.5rem 1.5rem 1.5rem;

        gap: 0.75rem;

        border-radius: 0.5rem;
        background-color: #FFFFFF;
    }
`;

export const ContainerSocial = styled.div` 
    width: 100%;
    height: auto;
 
    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    >div:nth-of-type(2){
        width: 100%;
    }

    >a{
        width: 100%;
        height: auto;

        display: flex;
        align-items: center;
        justify-content: center;
       
        cursor: pointer;
    }

    @media (max-width: 767px) {
        gap: 0.75rem; 
    }
`;

export const Social = styled.button` 
    all:unset;

    width: 90%;
    height: 1.25rem;
    padding: 0.75rem 1rem;
 
    gap: 0.75rem;
    display: flex;

    cursor: pointer;
    border-radius: 10rem;
    border: 1px solid ${theme.colors.gray.Cinza_2};

    >img{
        height: auto;
        width: 1.25rem;
    }

    >p{
        width: 100%;

        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
    }

    >label{
        width: 100%;
        
        display: flex;

        >img{
            height: auto;
            width: 1.25rem;
        }

        >p{
            width: 100%;

            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;
            text-transform: uppercase;

            color: ${theme.colors.gray.Cinza_2};
            font-weight: 800;
            font-size: 0.625rem;
            font-family: 'Lato';
            letter-spacing: 0.1em;
            line-height: 0.9375rem;
        }
    }
`;

export const ButtonLogin = styled.button` 
    all: unset;

    width: 100%;
    height: 3rem; 
    max-width: 21.1875rem; 

    cursor: pointer;

    >p{
        cursor: pointer;
        text-align: center;
    }
`;

export const ContainerDivider = styled.div` 
    width: 100%;
    height: auto;
 
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Divider = styled.div` 
    width: 100%;
    height: 0.0625rem;
    max-width: 11.875rem;
 
    background-color: #E9ECF0;
`;

export const ContainerInputs = styled.div` 
    width: 100%;
    height: auto;

    gap: 1rem; 
    display: flex;
    flex-direction: column;
`;

export const ContainerButtonsAndTerms = styled.div` 
    width: 100%;
    height: auto;

    gap: 3rem;
    display: flex;
    flex-direction: column;

    >p:last-child{
        text-align: center;
    }

    label{
        cursor: pointer;

        color: ${theme.colors.gray.Cinza_2};
        font-weight: 700;
    }

    @media (max-width: 767px) {
        p {
            color: #303848;

            label{
                cursor: pointer;

                font-weight: 700;
                color: #589BFF;
            }
        }
    }
`;

export const ContainerButtons = styled.div` 
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
`;

export const FormButton = styled.button`
    all: unset;

    height: 1.5rem;
    width: 6.3125rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    border-radius: 10rem;
    background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : `${theme.colors.green.Verde_AgroReceita}`)}; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        text-transform: uppercase;
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

        color: ${({ disabled }) => (disabled ? '#AAAAAA' : '#FFFFFF')};
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;
        transition: filter 0.3s ease; 
        filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')}; 
    }

    &:hover {
        background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : '#259D57')};
    }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid #FFFFFF;
  border-bottom:1px solid #FFFFFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const ContainerRegistration = styled.div` 
    height: 2.5rem;
    width: 8.4375rem;

    display: flex;
    align-items: center;
    justify-content: center;

    >a >p{
        cursor: pointer;
    }
`;